export enum MenuSection {
  DOCUMENTS = 'Document & References',
  PORTAL_ADMIN = 'Admin',
  CLIENTS = 'Clients',
  USERS = 'Users',
  XCO = 'Co-locations & Cross-connects',
  BW = 'Bandwidth',
  MD = 'Market Data',
  PTE = 'Precision Time Exchange',
  TOOLS = 'Tools',
  INFOS = 'Infos'
}
